import styles from "./style.module.scss";

import DynamicForm, { DynamicFormRef } from "@mavichpe/dynamic-forms";
import { forwardRef, useEffect, useRef } from "react";
import SellReportFormConfig from "./form";
import { Button, Col, Row } from "reactstrap";
import { getMonthBoundaries } from "@utils/Utils";
import { SellReportFormDataType } from "@/formTypes/SellReportFormDataType";
import { REPORT_EXCEL_FORMAT, REPORT_PRINT_FORMAT } from "@utils/Constants";

type SellReportFormProps = {
}

const SellReportForm = forwardRef<DynamicFormRef, SellReportFormProps>(
  (props, ref) => {
    const formRef = useRef<DynamicFormRef>(null);

    useEffect(() => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      formRef.current?.resetFormValue({
        clientId: "-2",
        zoneId: "-2",
        month,
        year
      })
    }, [])

    const getFormConfig = () => {
      return SellReportFormConfig;
    }

    const generateForm = (formData: SellReportFormDataType) => {
      const { startDate, endDate } = getMonthBoundaries(`${formData.year}`, `${formData.month}`)
      if (formData.format == REPORT_PRINT_FORMAT) {
        window.open(`/user/reports/print/sellByPeriod/${formData.clientId}/${formData.zoneId}/${startDate}/${endDate}`, "_blank")
      } else if (formData.format == REPORT_EXCEL_FORMAT) {
        const detallarIva = formData.detallarIva ? "1" : "0";
        window.open(`/user/reports/excel/sellByPeriod/${formData.clientId}/${formData.zoneId}/${startDate}/${endDate}/${detallarIva}`, "_blank")
      }
    }

    return (
      <>
        <DynamicForm<SellReportFormDataType>
          ref={formRef}
          id="report"
          formConfig={getFormConfig()}
          onSubmit={generateForm}
        >
          <Row>
            <Col md={{
              offset: 2
            }}>
              <Button className="me-3" type="submit" color="primary" size="lg">Generar Report</Button>
            </Col>
          </Row>
        </DynamicForm>
      </>
    )
  }
);

export default SellReportForm;